import React, { Component } from 'react';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table';
import {Card, CardTitle, CardText, CardActions} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import Chip from 'material-ui/Chip';
import ReactTooltip from 'react-tooltip'

import CerseActions from '../../actions/CerseActions';
import CerseStore from '../../stores/CerseStore';

class Page extends Component {
  state = {
    content: CerseStore.getState().formsContent,
    methods: CerseStore.getState().methods,
    phases: CerseStore.getState().phases,
    objectives: CerseStore.getState().objectives,
    maturity: CerseStore.getState().maturity,
  };

  downloadCsv() {
    let articles = this.state.content.rowsSelected.map(pos => this.state.content.articlesProcessed[pos]);

    CerseActions.downloadCsv(articles);
  }
  downloadBib() {
    let articles = this.state.content.rowsSelected.map(pos => this.state.content.articlesProcessed[pos]);

    CerseActions.downloadBib(articles);
  }

  intersection(items,store) {
    return store.filter(storeLinha =>
      items.find(item => storeLinha.value === item) !== undefined
    );
  }

  findMethods(methods) {
    return this.intersection(
      (methods||'').split(this.state.separator),
      this.state.methods);
  }

  findPhases(phases) {
    return this.intersection(
      (phases||'').split(this.state.separator),
      this.state.phases);
  }

  findObjectives(objectives) {
    return this.intersection(
      (objectives||'').split(this.state.separator),
      this.state.objectives);
  }

  displayMaturity(maturity) {
    return this.intersection(
      (maturity||'').split(this.state.separator),
      this.state.maturity)
      .map(linha => linha.label)
      .join(", ");
  }

  render() {
    let articles = this.state.content.rowsSelected.map(pos => this.state.content.articlesProcessed[pos]);

    return (
      <Card>
        <CardTitle title="Export References" subtitle="4/5" />
        <CardText>
          <p>Follows the list of guidelines and supporting literature selected:</p>

          <Table
            selectable={false}
            multiSelectable={false}
            height='300px'
            >
              <TableHeader
                displaySelectAll={false}
                enableSelectAll={false}
                >
                <TableRow>
                  <TableHeaderColumn>Instrument</TableHeaderColumn>
                  <TableHeaderColumn>Research method(s)</TableHeaderColumn>
                  <TableHeaderColumn>Process phase(s)</TableHeaderColumn>
                  <TableHeaderColumn>Type(s)</TableHeaderColumn>
                  <TableHeaderColumn>Maturity level</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody>
                {articles
                  .map((linha, key) =>
                  <TableRow
                    selected={this.state.content.rowsSelected.includes(key)}
                    key={key}>
                    <TableRowColumn style={{'text-overflow': null, 'white-space': null}}>
                      {linha.instrument}
                    </TableRowColumn>
                    <TableRowColumn style={{'text-overflow': null, 'white-space': null}}>
                      <div style={{display: 'flex', flexWrap: 'wrap'}}>
                        {this.findMethods(linha.methods).map((j, mkey) =>
                          <div>
                            <Chip data-tip data-for={key+'met'+mkey} >
                              {j.label}
                            </Chip>
                            <ReactTooltip effect='solid' id={key+'met'+mkey}>
                              <span>{j.description}</span>
                            </ReactTooltip>
                          </div>
                        )}
                      </div>
                    </TableRowColumn>
                    <TableRowColumn style={{'text-overflow': null, 'white-space': null}}>
                      <div style={{display: 'flex', flexWrap: 'wrap'}}>
                        {this.findPhases(linha.phases).map((j, mkey) =>
                          <div>
                            <Chip data-tip data-for={key+'pha'+mkey} >
                              {j.label}
                            </Chip>
                            <ReactTooltip effect='solid' id={key+'pha'+mkey}>
                              <span>{j.description}</span>
                            </ReactTooltip>
                          </div>
                        )}
                      </div>
                    </TableRowColumn>
                    <TableRowColumn style={{'text-overflow': null, 'white-space': null}}>
                      <div style={{display: 'flex', flexWrap: 'wrap'}}>
                        {this.findObjectives(linha.objective).map((j, mkey) =>
                          <div>
                            <Chip data-tip data-for={key+'obj'+mkey} >
                              {j.label}
                            </Chip>
                            <ReactTooltip effect='solid' id={key+'obj'+mkey}>
                              <span>{j.description}</span>
                            </ReactTooltip>
                          </div>
                        )}
                      </div>
                    </TableRowColumn>
                    <TableRowColumn style={{'text-overflow': null, 'white-space': null}}>
                      {this.displayMaturity(linha.maturity)}
                    </TableRowColumn>
                  </TableRow>
                )}
              </TableBody>
            </Table>

          <p>Download:</p>
        </CardText>
        <CardActions>
          <FlatButton label=".csv" onTouchTap={() => this.downloadCsv()} />
          <FlatButton label=".bib" onTouchTap={() => this.downloadBib()} />
        </CardActions>
      </Card>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Cerse/Step4.js